import { useMutation } from "react-query";
import getRegtankLivenessWebVerifyStatus from "../services/getRegtankLivenessWebVerifyStatus";

function useGetRegtankLivenessWebVerifyStatus() {
  return useMutation(
    ["regtank-liveness-web-verify-status"],
    getRegtankLivenessWebVerifyStatus
  );
}

export default useGetRegtankLivenessWebVerifyStatus;
